module.exports = __webpack_public_path__ + "static/media/spinner.0d622e5c.svg";